<template>
  <div>
    <CSidebarNavTitle v-if="hasAnyPerms([
      'menu.orders',
      'pica.view_photoservice',
      'dashboard.change_event_turnover',
      'contract_manager.list',
      'event_owner.list',
    ])">{{ $gettext('Administration') }}</CSidebarNavTitle>
    
    <CSidebarNavItem
      v-if="hasAnyPerms(['menu.orders'])"
      :name="$gettext('Orders')"
      to="/manage/orders"
      icon="cip-cart"
    />
    
    <CSidebarNavItem
      v-if="hasAnyPerms(['pica.view_photoservice'])"
      :name="$gettext('Photo services')"
      to="/manage/photo-services"
      icon="cip-building"
    />
    
    <CSidebarNavItem
      v-if="hasAnyPerms(['dashboard.change_event_turnover'])"
      :name="$gettext('Events Data Entry')"
      to="/manage/events_data_entry"
      icon="cip-text-input"
    />
    
    <CSidebarNavItem
      v-if="hasAnyPerms(['contract_manager.list'])"
      :name="$gettext('Contract Manager')"
      :to="{name: 'contract_manager.list'}"
      icon="cip-heart-hand"
    />

    <CSidebarNavItem
      v-if="hasAnyPerms(['event_owner.list'])"
      name="Event Owner"
      :to="{name: 'event_owner.list'}"
      icon="cip-building"
    />
  </div>
</template>

<script>
export default {
  name: 'Administration'
}
</script>